import { defineStore } from "pinia";

import modelClass from "@models/exchange_report";
import * as getters from "@modelStores/helpers/getters-helper";

export const useExchangeReportStore = defineStore("exchange_report-store", {
  state: () => {
    return {
      resources: [] as Record<string, unknown>[],
    };
  },
  getters: {
    ...getters,
    modelClass: () => modelClass,
  },
});
